import React, { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import { FormControlLabelAndPopover } from "../FormControlLabel";
import { ValidationErrorsMessages } from "../FormValidation";
import { CultureHelper } from "./../../helpers/CultureHelper";

type TargetType = {
  target: {
    name: string;
    value: string;
  }
};

type CitySearcherProps = {
  field: Field;
  handleChange: (target: TargetType) => void;
  handleBlur: () => void;
  formDataEntry: FormDataEntry;
  errors: {
    message: string, 
    html: any
  }[];
};

export const CitySearcherControl = ({ field, handleChange, handleBlur, formDataEntry, errors }: CitySearcherProps) => {
  const [locale, setLocale] = useState(null);
  
  useEffect(() => {
    const fetchCulture = async () => {
      const currentCulture = await CultureHelper.getCurrentCulture();
      setLocale(currentCulture.cultureImport);
    };

    fetchCulture();
  }, []);
  
  const handleDropDownChange = selectedOption => {
    handleChange({
      target: {
        name: field["@column"],
        value: selectedOption
      }
    });
  };

  const getItems = (input: string) => {
    let url = `/api/placenames/get?partialname=${input}`;
    return fetch(`${window.location.origin}/${url}`).then((res) => {
      
      return res.json();
    });
  };

  const value = formDataEntry.value ? formDataEntry.value : "";
  
  return (
    <div className={`form-group form__section-input ${field.properties?.fieldcssclass ?? ''}`}>
      <FormControlLabelAndPopover field={field} />
      {locale && (
        <AsyncSelect
          id={field["@column"]}
          name={field["@column"]}
          className="form-control searchahead-react-select"
          classNamePrefix="searchahead-react-select"
          value={value}
          placeholder={value}
          onChange={handleDropDownChange}
          loadOptions={getItems}
          getOptionLabel={(e) => e}
          getOptionValue={(e) => e}
          required={!field["@allowempty"]}
          noOptionsMessage={() => null}
          loadingMessage={() => null}
          locale={locale}
        />
      )}
      <ValidationErrorsMessages keyGuid={field["@guid"]} errors={errors} />
    </div>
  );
};